<template>
  <div class="dialogWrit" v-show="visible">
    <div class="keyboardChecker">
      <h3>主观题输入法测试</h3>
      <div class="line"></div>
      <div class="tip1">"请测试输入全部英文字母a到z、数字0到9、回车、空格、标点符号等基本做答功能键，确定按键正常"</div>
      <div class="tip2">正式考试系统仅支持本模拟系统中提示的输入法种类，应试人员可在电脑上安装、使用相关输入法进行模拟作答，以确保模拟答题效果。</div>
      <a href="javascript:void (0)" @click="isShowMethod = true" class="tip3">输入法</a>
      <textarea></textarea>
      <button type="button" class="close-btn" @click="closeDialog">关闭</button>
      <ul class="inputMethod" v-if="isShowMethod">
        <li v-for="(item,index) in options" :key="index" @click="isShowMethod=false">{{item}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DialogWriting',
  props: {
    visible: { type: Boolean, default: false }
  },
  data(){
    return{
      isShowMethod:false,
      options:[
        '微软拼音输入法',
        '谷歌拼音输入法',
        '搜狗拼音输入法',
        '极品五笔输入法',
        '万能五笔输入法',
      ]
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="scss" scoped>
  .keyboardChecker{
    position: absolute;
    left: 12%;
    top: 19%;
    width: 767px;
    height: 494px;
    border: 1px solid rgb(181, 255, 255);
    background: rgb(183, 218, 254);
    z-index: 999;
    display: block;
    h3{
      font-size: 25px;
      font-weight: bolder;
      position: absolute;
      top: 40px;
      left: 35px;
    }
    .line{
      width:733px;
      height:1px;
      border-top:solid rgb(0,0,0) 1px;
      position: absolute;
      top: 85px;
      left: 17px;
    }
    .tip1{
      font-size: 13px;
      font-family: Georgia;
      position: absolute;
      top: 110px;
      left: 40px;
    }
    .tip2{
      font-size: 13px;
      position: absolute;
      top: 138px;
      left: 42px;
      width: 585px;
    }
    .tip3{
      font-size: 16px;
      color: blue;
      position: absolute;
      top: 107px;
      left: 700px;
      cursor: pointer;
    }
    textarea{
      position: absolute;
      width: 700px;
      height: 261px;
      top: 184px;
      left: 30px;
    }
    ul{
      width: 196px;
      position: absolute;
      top: 128px;
      left: 600px;
      background-color: white;
      list-style: none;
      padding: 8px;
      color: rgb(0, 102, 220);
      border: 1px solid rgb(211, 211, 211);
      font-family: '宋体';
      li{
        cursor: pointer;
        line-height:18px;
        padding-bottom: 0;
      }
    }
    .close-btn{
      position: absolute;
      top: 458px;
      left: 360px;
      width: 60px;
      height: 30px;
    }
  }
</style>

